const faqs = [
  {
    id: 1,
    heading: 'How can I subscribe to a plan?',
    content: "You can subscribe to our services by visiting our website's 'Plans' page, choosing the plan that suits your needs, and completing the signup process. Our customer service team is also available to assist over the phone.",
  },
  {
    id: 2,
    heading: 'What packages are available?',
    content: 'We offer various packages including Internet-only, Cable TV, and Bundled services that combine both. Each package comes with options based on speed, channel count, and price to best fit your preferences.',
  },
  {
    id: 3,
    heading: 'What is the installation process?',
    content: 'Once you subscribe, our technician will contact you to schedule a convenient time for installation. The process typically takes 1-2 hours, depending on the service. Our team ensures a hassle-free setup for your home.',
  },
  {
    id: 4,
    heading: 'How does billing work?',
    content: 'Billing is done monthly, and you can choose automatic payments for convenience. You can view and pay your bill through your online account or set up recurring payments. We accept major credit cards and bank transfers.',
  },
  {
    id: 5,
    heading: 'How can I contact customer support?',
    content: "Our customer support team is available 24/7 via phone, email, and live chat. Visit our 'Contact Us' page for detailed support options, or log in to your account for troubleshooting guides and assistance.",
  },
];

export default faqs;